import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import Image from './Image';
import Input from './Input';
import Button from './Button';
import ContainerLoader from './ContainerLoader';
import SignUp from './SignUp';
import SignFindId from './SignFindId';
import SignFindPw from './SignFindPw';
import SignIn from './SignIn';

import images from '../libs/images';
import consts from '../libs/consts';

export default function Sign() {

    const ref = useRef();

    const { signPop, signTermPop, closeSignPop } = usePopup();
    const { user, token, login } = useUser();

    const [page, setPage] = useState('');
    const [password, setPassword] = useState('');

    const [error, setError] = useState({});

    const [remount, setRemount] = useState(false);
    const [processIndex, setProcessIndex] = useState(1);

    useEffect(() => {

        // toast.info('인포 입니다.');
        // toast.success('Success 입니다.');

        if (signPop) setRemount(true);

        else {
            setTimeout(() => {
                setRemount(false);
                setPage('');
            }, 300)
        }

    }, [signPop])

    const closeBg = () => {
        setPage('')
        setProcessIndex(1)
        closeSignPop();
    }

    const closeFunc = () => {
        if (page === "signIn") {
            console.log("signIn back", processIndex)
            if (processIndex > 1) setProcessIndex(processIndex - 1)
            else setPage('')
        } else if (page === "findId" || page === "findPw") {
            setPage('')
        } else {
            closeSignPop();
        }
    }

    return (
        <motion.div
            className="loader_box"
            initial={consts.loaderVariants.closed}
            animate={signPop ? "open" : "closed"}
            variants={consts.loaderVariants}
        >
            <motion.div
                className="loader_bg"
                initial={consts.loaderVariants.closed}
                animate={signPop ? "open" : "closed"}
                variants={consts.loaderVariants}
                onClick={e => {
                    if (e.target !== e.currentTarget) return;
                    // closeFunc();
                    closeBg()
                }}
            />

            <motion.div
                className="login_box"
                initial={consts.loginBoxVariants.closed}
                animate={(signPop) ? "open" : "closed"}
                variants={consts.loginBoxVariants}
                style={{ display: signTermPop ? 'none' : 'flex' }}
            >
                {/* <button className='exit_btn' onClick={closeFunc}/> */}
                <button className='exit_back_btn' onClick={closeFunc} />

                <SignUp remount={remount} page={page} setPage={setPage} />

                {page === 'findId' ? (
                    <SignFindId setPage={setPage} />
                ) : page === 'findPw' ? (
                    <SignFindPw setPage={setPage} />
                ) : page === 'signIn' ? (
                    <SignIn
                        setPage={setPage}
                        processIndex={processIndex}
                        setProcessIndex={setProcessIndex}
                    />
                ) : (
                    <></>
                )}

            </motion.div>


        </motion.div>
    )
}